import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
        minWidth: 0,
    },
    label: {
        color: theme.palette.text.secondary,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: 1.2,
    },
    valueRow: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1),
        minWidth: 0,
    },
    value: {
        color: theme.palette.text.primary,
        wordBreak: 'break-word',
        whiteSpace: 'pre-wrap',
        flex: 1,
        minWidth: 0,
    },
    empty: {
        color: theme.palette.text.secondary,
    },
}));
